<div class="modal-header">
  <h4 class="modal-title">Cookies op {{ hostname }}</h4>
</div>
<div class="modal-body">
  <p class="card-text">
    Hoi! Wij en wat andere partijen gebruiken cookies en vergelijkbare technologieën. Dat doen we om technische redenen. Maar met jouw toestemming ook
    voor betere
    <strong>functionaliteit, ervaring, metingen en gepersonaliseerde advertenties</strong>. Meer info vind je in ons
    <a [routerLink]="['/cookie-policy']" target="_blank" style="outline: none">cookiebeleid</a>.
  </p>

  <p></p>
  <p>Klik op “Accepteren” als je dat goed vindt. Klik op “Afwijzen” als je dat niet wilt.</p>
</div>
<div class="modal-footer justify-content-end">
  <button type="button" class="btn btn-secondary" (click)="reject()">Afwijzen</button>
  <button #acceptButton type="button" class="btn btn-primary" (click)="accept()">Accepteren</button>
</div>
